module.exports = __webpack_public_path__ + "img/vera.686a2db1.svg";